export default "__VITE_ASSET__C_Rz_K7F__"